import React, { useEffect } from "react";
import InputBox from "../components/InputBox";
import Select from "react-select";
import ProfilePhotoOnly from "../components/ProfilePhotoOnly";
import { useSelector } from "react-redux";
import { setDocData } from "../Firebase/Firebase.utils";
import toast from "react-hot-toast";

function EditTaskForm({ task, requirementData, handleEditMode }) {
  const currentUser = useSelector((state) => state.userObject);
  const [formData, setFormData] = React.useState(task);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [teamMembers, setTeamMembers] = React.useState(
    requirementData.team_members
  );

  const options = teamMembers.map((member) => ({
    value: member,
    label: <ProfilePhotoOnly email={member} />,
  }));

  useEffect(() => {}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelect = (selectedOption) => {
    setFormData({
      ...formData,
      assignee_emails: selectedOption.map((option) => option.value),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const docObject = {
      ...formData,
      status: "Open",
      updatedAt: new Date().toISOString(),
      lastUpdatedBy: currentUser.email,
    };
    setIsSubmitting(true);
    await setDocData("tasks", task.id, docObject);
    setIsSubmitting(false);
    setFormData({});
    handleEditMode();
    toast.success("Task updated successfully");
  };

  return (
    <div className="small-form relative">
      <div className="header">Add New Task</div>
      <button className="close-button" onClick={handleEditMode}>
        Close
      </button>

      <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
        <InputBox
          label="Task Name"
          placeholder="Enter task name"
          type="text"
          required
          name="task_name"
          onChange={handleChange}
          value={formData.task_name}
        />

        <InputBox
          label="Task Description"
          placeholder="Enter task description"
          type="text"
          name="description"
          onChange={handleChange}
          value={formData.description}
        />

        <InputBox
          label="Due Date"
          type="date"
          required
          name="due_date"
          onChange={handleChange}
          value={formData.due_date}
        />

        <div>
          <label
            htmlFor=""
            className="text-sm font-semibold text-gray-600 uppercase"
          >
            Assigned To
          </label>
          <Select
            className="w-80"
            options={options}
            isMulti={true}
            onChange={handleSelect}
            required
            value={
              formData.assignee_emails &&
              formData.assignee_emails.map((email) => ({
                value: email,
                label: <ProfilePhotoOnly email={email} />,
              }))
            }
          />
        </div>

        <button className="blue-button" type="submit">
          {isSubmitting ? "Updating Task..." : "Save Task"}
        </button>
      </form>
    </div>
  );
}

export default EditTaskForm;
